export const DISPUTES_SLICE_NAME = "disputes"
